import React from "react";
import { useNavigate } from "react-router-dom";
//import axios from "axios";
import api from "../api/axios";
import avatarImg from "../assets/images/users/avatar-6.png";

function Logout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const token = localStorage.getItem("accessToken");

    try {
      await api.post(
        "/logout",
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Remove token from localStorage
      //localStorage.removeItem("accessToken");

      // Clear both storages completely
      localStorage.clear();
      sessionStorage.clear();

      // Redirect to login
      navigate("/");
    } catch (error) {
      console.error("Logout failed", error);
      // Still force logout client-side if API fails
      localStorage.removeItem("accessToken");
      navigate("/");
    }
  };

  return (
    <div className="dropdown d-inline-block">
      <button
        type="button"
        className="btn btn-sm top-icon p-0"
        id="page-header-user-dropdown"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <img
          className="rounded avatar-2xs p-0"
          src={avatarImg}
          alt="Header Avatar"
        />
      </button>
      <div className="dropdown-menu dropdown-menu-wide dropdown-menu-end dropdown-menu-animated overflow-hidden py-0">
        <div className="card border-0">
          <div className="card-header bg-primary rounded-0">
            <div className="rich-list-item w-100 p-0">
              <div className="rich-list-prepend">
                <div className="avatar avatar-label-light avatar-circle">
                  <div className="avatar-display">
                    <i className="fa fa-user-alt"></i>
                  </div>
                </div>
              </div>
              <div className="rich-list-content">
                <h3 className="rich-list-title text-white">Account-User</h3>
                <span className="rich-list-subtitle text-white">
                  accounts@hub.com
                </span>
              </div>
              {/* <div className="rich-list-append">
                <span className="badge badge-label-light fs-6">6+</span>
              </div> */}
            </div>
          </div>

          <div className="card-body p-0">
            <div className="grid-nav grid-nav-flush grid-nav-action grid-nav-no-rounded">
              <div className="grid-nav-row">
                {/* ... other menu items ... */}
              </div>
            </div>
          </div>

          <div className="card-footer card-footer-bordered rounded-0">
            <button
              onClick={handleLogout}
              className="btn btn-label-danger w-100"
            >
              Sign out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Logout;
